import _ from 'lodash'

export function fullName(person, diplayLastNameFirst) {
  const first = _.get(person, 'firstName', null)
  const last = _.get(person, 'lastName', null)

  if (!first && !last) return null
  if (first && !last) return first
  if (last && !first) return last
  if (diplayLastNameFirst) return `${last}, ${first}`
  return `${first} ${last}`
}

export function initials(patient) {
  const firstInitial =
    patient && !_.isEmpty(patient.firstName) && !_.isEmpty(patient.firstName.trim())
      ? patient.firstName.charAt(0)
      : ''
  const lastInitial =
    patient && !_.isEmpty(patient.lastName) && !_.isEmpty(patient.lastName.trim())
      ? patient.lastName.charAt(0)
      : ''
  const initials = `${firstInitial}${lastInitial}`
  return _.isEmpty(initials) ? null : initials
}

export function presentationPatientName(presentationPatient) {
  if (presentationPatient.showName) {
    if (presentationPatient.showInitials) {
      return initials(presentationPatient.patient)
    } else {
      return fullName(presentationPatient.patient)
    }
  }
  return null
}
